/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import TextNumber from './components/TextNumber';
import CardHeader from './CardHeader';
import ServiceTable from './ServiceTable';
import { getWorkedTimeAverageTime } from '../../../utils/calculatorHelper';

export interface IServiceByService {
  calendarEvenState?: string;
  detailInfo: any;
  detailProjectId: any;
  mutateAction: () => void;
  onlyTask: boolean;
  projectType: string;
  service: any;
  servicesInfo: any;
  setOnlyTask: React.Dispatch<React.SetStateAction<any>>;
  type: string;
  typeView: string;
}

const ServiceByService: React.FC<IServiceByService> =
  function ServiceByService({
    service,
    servicesInfo,
    type,
    typeView,
    detailProjectId,
    onlyTask,
    setOnlyTask,
    detailInfo,
    projectType,
    mutateAction,
    calendarEvenState
  }) {
    const [isOpen, setIsOpen] = useState(type === 'serviceTime' ? true : false);
    const [step, setStep] = useState<number>(0);
    const [auxTime, setAuxTime] = useState<any>();

    useEffect(() => {
      let auxTimeSum = 0;
      let sumWorkedTime = 0;

      if (service) {
        service?.tasks?.forEach((task: any) => {
          if (task?.technicians?.length > 0) {
            auxTimeSum +=
              (task?.totalTimeInHours || 1) / (task?.technicians?.length || 1);
          } else {
            auxTimeSum +=
              (task?.totalTimeInHours || 1) / (task?.minimumResources || 1);
          }

          if (task?.taskIteration?.length > 0) {
            sumWorkedTime += getWorkedTimeAverageTime(task?.taskIteration);
          }
        });

        setAuxTime({
          estimated: auxTimeSum,
          projectType,
          total: sumWorkedTime
        });
      }
    }, [service]);

    // For serviceTime: render table directly, no sub-header or tabs
    if (type === 'serviceTime') {
      return (
        <Box>
          {onlyTask === false && service.tasks.length > 0 ? (
            <ServiceTable
              calendarEvenState={calendarEvenState || undefined}
              dashboard={service.tasks}
              mutateAction={mutateAction}
              onlyTask={onlyTask}
              serviceInfo={{
                ...detailInfo,
                timezone:
                  detailProjectId?.proposal?.lead?.address?.timezoneIANA ||
                  detailInfo?.timezone
              }}
              typeView="serviceTime"
            />
          ) : (
            <ServiceTable
              calendarEvenState={calendarEvenState || undefined}
              dashboard={service.tasks}
              mutateAction={mutateAction}
              onlyTask={onlyTask}
              serviceInfo={{
                ...detailProjectId?.proposal?.lead?.serviceTimes?.[0],
                timezone:
                  detailProjectId?.proposal?.lead?.address?.timezoneIANA ||
                  detailInfo?.timezone
              }}
              typeView="serviceTime"
            />
          )}
        </Box>
      );
    }

    // serviceSetup view – show sub-header + tabs
    return (
      <Box sx={{ borderTop: '1px solid #E2E4EA' }}>
        <CardHeader
          componentType="estimated"
          isOpen={isOpen}
          projectType={projectType}
          propsTime={auxTime}
          setIsOpen={setIsOpen}
          title={service?.name}
        />
        {isOpen && (
          <Box>
            <Box
              sx={{
                backgroundColor: '#F5F6F8',
                borderTop: '1px solid #E2E4EA',
                display: 'flex',
                flexDirection: 'row',
                padding: '6px 12px'
              }}
            >
              <Tabs
                aria-label="service task tabs"
                onChange={(_: React.SyntheticEvent, newValue: number) =>
                  setStep(newValue)
                }
                sx={{
                  '& .MuiTab-root': {
                    '&.Mui-selected': { color: '#005DA2', fontWeight: 700 },
                    color: '#7D8090',
                    fontSize: '11px',
                    fontWeight: 500,
                    minHeight: 32,
                    padding: '0 10px',
                    textTransform: 'none'
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#005DA2',
                    height: 2
                  },
                  minHeight: 32
                }}
                value={step}
              >
                {service && (
                  <Tab
                    label={
                      <TextNumber
                        isActive={step}
                        number={service.tasks.length.toString()}
                        position={0}
                        text="Tasks"
                      />
                    }
                  />
                )}
              </Tabs>
            </Box>
            <Box>
              {onlyTask === false && service.tasks.length > 0 ? (
                <ServiceTable
                  calendarEvenState={calendarEvenState || undefined}
                  dashboard={service.tasks}
                  mutateAction={mutateAction}
                  onlyTask={onlyTask}
                  serviceInfo={{
                    ...detailInfo,
                    timezone:
                      detailProjectId?.proposal?.lead?.address?.timezoneIANA ||
                      detailInfo?.timezone
                  }}
                  typeView="serviceSetup"
                />
              ) : (
                <ServiceTable
                  calendarEvenState={calendarEvenState || undefined}
                  dashboard={service.tasks}
                  mutateAction={mutateAction}
                  onlyTask={onlyTask}
                  serviceInfo={{
                    ...detailProjectId?.proposal?.lead?.serviceTimes?.[0],
                    timezone:
                      detailProjectId?.proposal?.lead?.address?.timezoneIANA ||
                      detailInfo?.timezone
                  }}
                  typeView="serviceSetup"
                />
              )}
            </Box>
          </Box>
        )}
      </Box>
    );
  };
ServiceByService.defaultProps = {
  calendarEvenState: undefined
};
export default ServiceByService;
